import { useCallback, useState } from 'react';
import { notify } from '../components/common/AppToast';
import kkpService from '../services/kkpService';
import {
  BAT_VALIDE_RESTRICTED_MESSAGE,
  canSetBatValide,
  interceptLockedBatValideChange,
  isBatValideOptionLocked,
  isBatValideStatut,
  batValideOptionTitle,
} from '../utils/kkpBatValide';

export function useKkpBatValideFlow({ onUpdated } = {}) {
  const [vente, setVente] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const canSet = canSetBatValide();

  const close = useCallback(() => {
    if (submitting) return;
    setVente(null);
    setError(null);
  }, [submitting]);

  const open = useCallback((nextVente) => {
    if (!nextVente?.id) return;
    setError(null);
    setVente(nextVente);
  }, []);

  const submit = useCallback(async (files = []) => {
    if (!vente?.id || submitting) return;
    setSubmitting(true);
    setError(null);
    try {
      const data = await kkpService.validerBat(vente.id, files);
      onUpdated?.(data.vente, data.notice ?? null);
      if (data.notice) {
        notify.warning(data.notice);
      } else {
        notify.success('BAT validé. Un e-mail a été envoyé au commercial.');
      }
      setVente(null);
    } catch (err) {
      setError(err.message || 'Impossible de valider le BAT');
    } finally {
      setSubmitting(false);
    }
  }, [onUpdated, submitting, vente]);

  const statutSelectProps = useCallback((row) => ({
    isOptionBlocked: (value) => isBatValideOptionLocked(value),
    optionTitle: (value) => batValideOptionTitle(value),
    onBlockedOptionSelect: () => notify.warning(BAT_VALIDE_RESTRICTED_MESSAGE),
    onSelectIntercept: (value) => {
      if (!isBatValideStatut(value) || !canSet || !row?.id) {
        return false;
      }
      if (isBatValideStatut(row.statut_phase)) {
        return false;
      }
      open(row);
      return true;
    },
  }), [canSet, open]);

  return {
    batValideVente: vente,
    batValideSubmitting: submitting,
    batValideError: error,
    openBatValide: open,
    closeBatValide: close,
    submitBatValide: submit,
    statutSelectProps,
    interceptLockedBatValideChange,
  };
}
